import * as React from "react";

import PageHeader from "@replo/design-system/blocks/page-header/PageHeader";
import { DubDashboard } from "@v2/features/dub/DubDashboard";

export const MyReferrals = () => {
  return (
    <div className="flex flex-col w-full h-full gap-4">
      <PageHeader
        title="My Referrals"
        description="View your monthly referral earnings and copy your referral links."
      />
      <DubDashboard />
    </div>
  );
};
